export const REACT_APP_OLD_PASSWORD_HASH = '$2a$04$Sxhz3/uiPO.Sxhz3/uiPO.';
